import React from 'react';
import styles from './Listing.module.css';
import ListingHeader from './ListingHeader';
import ListingItem from './ListingItem';

const Listing = ({
    items = [],
    renderItem,
    title,
    description,
    actions,
    filters,
    loading = false,
    emptyTitle = "No items found",
    emptyDescription = "We couldn't find any items matching your criteria.",
    emptyIcon = "📁",
    className = "",
    variant = "list"
}) => {
    return (
        <div className={`${styles.listingContainer} ${className}`}>
            {(title || description || actions || filters) && (
                <ListingHeader
                    title={title}
                    description={description}
                    actions={actions}
                    filters={filters}
                />
            )}

            {loading ? (
                <div className={styles.loadingWrapper}>
                    {/* Skeleton or Spinner */}
                    <p>Loading...</p>
                </div>
            ) : items.length > 0 ? (
                <div className={`${styles.itemsGrid} ${styles[variant]}`}>
                    {items.map((item, index) => (
                        renderItem ? renderItem(item, index, variant) : (
                            <ListingItem
                                key={item.id || index}
                                title={item.title || item.name}
                                subtitle={item.subtitle || item.description}
                                variant={variant}
                            />
                        )
                    ))}
                </div>
            ) : (
                <div className={styles.emptyState}>
                    <div className={styles.emptyIcon}>{emptyIcon}</div>
                    <h3 className={styles.emptyTitle}>{emptyTitle}</h3>
                    <p className={styles.emptyDescription}>{emptyDescription}</p>
                </div>
            )}
        </div>
    );
};

export default Listing;
